import { render, staticRenderFns } from "./RegisterEntity.vue?vue&type=template&id=826bd960&scoped=true"
import script from "./RegisterEntity.vue?vue&type=script&lang=js"
export * from "./RegisterEntity.vue?vue&type=script&lang=js"
import style0 from "./RegisterEntity.vue?vue&type=style&index=0&id=826bd960&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "826bd960",
  null
  
)

export default component.exports